export enum LogLevelValue {
  critical = 0,
  error = 1,
  warn = 2,
  info = 3,
  verbose = 4,
  debug = 5,
}

export const LogLevelValueFromString: Record<
  keyof typeof LogLevelValue,
  LogLevelValue
> = {
  critical: LogLevelValue.critical,
  error: LogLevelValue.error,
  warn: LogLevelValue.warn,
  info: LogLevelValue.info,
  verbose: LogLevelValue.verbose,
  debug: LogLevelValue.debug,
} as const;

export type LogLevel = keyof typeof LogLevelValueFromString;

export type LogActions = {
  [level in LogLevel]: (message: string, ...args: unknown[]) => void;
};

export interface Log {
  log(level: LogLevel, message: string, ...args: unknown[]): void;
}
